import { useState } from 'react';
import { Container, ButtonGroup, Button, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { blueGrey } from '@mui/material/colors';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const StyledButton = styled(Button)(() => ({
  color: 'var(--ts-surface)',
  backgroundColor: 'var(--ts-primary)',
  borderColor: 'none',
  '&:hover': {
    backgroundColor: 'var(--ts-primary)',
    borderColor: 'none',
  },
}));

const StyledInput = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderRadius: 0,
      borderColor: 'var(--ts-primary-light)',
    },
    '&:hover fieldset': {
      borderColor: 'var(--ts-primary-dark)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'var(--ts-primary-dark)',
    },
    '& input': {
      textAlign: 'center',
      width: 60,
      color: 'var(--ts-text-dark)',
    },
  },
});

const TSCounter = ({ count, setCount }) => {
  const handleChange = (event) => {
    setCount(Math.max(Number(event.target.value), 1));
  };
  return (
    <Container>
      <ButtonGroup>
        <StyledButton
          onClick={() => setCount((prev) => prev - 1)}
          disabled={count === 0}
        >
          <RemoveIcon fontSize="small" />
        </StyledButton>
        <StyledInput size="small" onChange={handleChange} value={count} />
        <StyledButton onClick={() => setCount((prev) => prev + 1)}>
          <AddIcon fontSize="small" />
        </StyledButton>
      </ButtonGroup>
    </Container>
  );
};

export default TSCounter;
